export enum Variant {
	AchieveEarlyAccess = 'one-on-ones',
	AchieveLimitedRelease = 'achieve-limited-release',
	OneOnOnesExperimental = 'one-on-ones-experimental',
	AchieveR3FastFollows = 'achieve-adoption-r3-fast-follows',
}
